import { render, staticRenderFns } from "./Ddx.vue?vue&type=template&id=442b85e8"
import script from "./Ddx.vue?vue&type=script&lang=js"
export * from "./Ddx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports